import { IScreenControllerTranslations } from "./connector/__types__/UIViewController";
import { ScreenControllerTranslations } from "./connector/UIViewController";
import TranslationsTable from "./components/Table/Table";
import TranslationsHead from "./components/Head/Head";
import React, { useEffect } from "react";
import { useControllers } from "@view/hooks/useControllers";
import withControllers from "@view/root/__proto__/withController";
import { TranslationService } from "@services/translate";
import { Helmet } from "react-helmet-async";

const TranslationScreen = (): JSX.Element => {
  const { UIViewController } = useControllers<{
    UIViewController: IScreenControllerTranslations;
  }>();

  useEffect(() => {
    UIViewController.fetchListOfTranslations();
  }, []);

  return (
    <>
      <Helmet>
        <title>{TranslationService.t("txt_translates")}</title>
      </Helmet>

      <TranslationsHead />
      <TranslationsTable />
    </>
  );
};

export default withControllers(ScreenControllerTranslations)(TranslationScreen);
